<div class="container">

  @if (isLoginPage) {
    <app-header></app-header>
  }
  @if (spinnerStarted) {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  @if (isLoginPage) {
    <mat-sidenav-container>
      <mat-sidenav
        #sidenav
        mode="side"
        opened
        class="mat-elevation-z8 app-sidenav"
        [style.width.em]="sidenavWidth"
        (mouseenter)="increase()"
        (mouseleave)="decrease()">

        <mat-nav-list style="padding-left: 0px !important;">
          <div class="display-layout-column layout-gap-0">

            <a mat-list-item routerLink="/requests" routerLinkActive="active-list-item">
              <mat-icon matListItemIcon>chat</mat-icon>
              <span matListItemTitle class="settingName">Requests</span>
            </a>

            <mat-divider></mat-divider>

            <div>
              <a mat-list-item routerLink="/main-settings" routerLinkActive="active-list-item">
                <mat-icon matListItemIcon>settings</mat-icon>
                <span matListItemTitle class="settingName">Main Settings</span>
              </a>
              <a mat-list-item routerLink="/customer-settings" routerLinkActive="active-list-item">
                <mat-icon matListItemIcon>group</mat-icon>
                <span matListItemTitle class="settingName">Customers</span>
              </a>
              <a mat-list-item routerLink="/airline-settings" routerLinkActive="active-list-item">
                <mat-icon matListItemIcon>flight_land</mat-icon>
                <span matListItemTitle class="settingName">Airlines</span>
              </a>
              <a mat-list-item routerLink="/broker-settings" routerLinkActive="active-list-item">
                <mat-icon matListItemIcon>show_chart</mat-icon>
                <span matListItemTitle class="settingName">Brokers</span>
              </a>
              <a mat-list-item routerLink="/gsa-settings" routerLinkActive="active-list-item">
                <mat-icon matListItemIcon>connect_without_contact</mat-icon>
                <span matListItemTitle class="settingName">GSAs</span>
              </a>
              <a mat-list-item routerLink="/user-settings" routerLinkActive="active-list-item">
                <mat-icon matListItemIcon>supervised_user_circle_outline</mat-icon>
                <span matListItemTitle class="settingName">Users</span>
              </a>
            </div>
          </div>
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content class="display-flex display-layout-column">
        <div class="contentContainer">
          <router-outlet></router-outlet>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  }

  @if (!isLoginPage) {
    <div>
      <app-login></app-login>
    </div>
  }
</div>
